export default import.meta.ROLLUP_FILE_URL_2U$WOXZWQa5GXpwNs7P1uw